import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-form-control',
  templateUrl: './form-control.component.html',
  styleUrls: ['./form-control.component.scss']
})
export class FormControlComponent implements OnInit {
@Input() label:string;
  constructor() { }

  ngOnInit(): void {
  }

}
